const headers = [
  {
    text: '',
    value: '',
    width: '80px'
  },
  {
    text: 'common.common_upload-date',
    value: 'uploadedDate',
    width: '120px'
  },
  {
    text: 'jd.jd_jdcom-store-name',
    value: 'shopName',
    width: '120px'
  },
  {
    text: 'order.order_rep',
    value: 'userId',
    width: '80px'
  },
  {
    text: 'common.common_control-number',
    value: 'exCsvFileNumber',
    width: '200px'
  },
  {
    text: 'sale.sale_status',
    value: 'status',
    width: '120px'
  },
  {
    text: 'sale.sale_choice-sale-operation',
    value: 'action'
  }
]

const productListHeaders = [
  {
    text: 'sale.sale_sale-number',
    value: 'orderNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_payment-total-amount',
    value: 'topayAmount',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end'
  },
  {
    text: 'sale.sale_deliver-info',
    value: 'packingService',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_sale-note',
    value: 'orderNote',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'jd.jd_productid-skuid',
    value: 'exProductNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'jd.jd_product-name',
    value: 'exProductName',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'jd.jd_delivery-request-product-name',
    value: 'shipProductName',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.common_product-quantity',
    value: 'quantity',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'jd.csv_ship-request-status',
    value: 'csv.status',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'jd.csv_sale-register-status',
    value: 'hasSaleRegistered',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: '',
    value: 'checkbox',
    checkbox: true,
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

const productListHeadersForEdit = [
  {
    text: 'sale.sale_status',
    value: 'product.disabledFlg',
    sortable: false,
    width: '6%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'product.taxId',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '%'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'product.product_purchase-price',
    value: 'price',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '円'
  },
  {
    text: 'common.input_order-quantity',
    value: 'quantity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '円'
  }
]

export default {
  headers,
  // tableKey,
  productListHeaders,
  productListHeadersForEdit
}
